var render, staticRenderFns
import script from "./_activity_id.vue?vue&type=script&lang=tsx&"
export * from "./_activity_id.vue?vue&type=script&lang=tsx&"
import style0 from "./_activity_id.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports